import { defineStore } from "pinia";

export interface LayoutState {
  isAutoFold: boolean;
  isPrimaryMinimized: boolean;
  isSecondaryOpen: boolean;
  collapsedPages: {
    [key: string]: boolean; // key: 페이지 URL 또는 식별자, value: collapse 상태
  };
}

export const useLayoutStore = defineStore("layout", {
  persist: {
    storage: localStorage,
  },
  state: (): LayoutState => ({
    isAutoFold: true,
    isPrimaryMinimized: false,
    isSecondaryOpen: false,
    collapsedPages: {},
  }),
  actions: {
    setAutoFold(bool: boolean) {
      this.isAutoFold = bool;
    },
    togglePrimarySidebar() {
      this.isPrimaryMinimized = !this.isPrimaryMinimized;

      if (this.isSecondaryOpen && !this.isPrimaryMinimized) {
        this.isPrimaryMinimized = true;
      }
    },
    toggleSecondarySidebar() {
      this.isSecondaryOpen = !this.isSecondaryOpen;
      this.isPrimaryMinimized = this.isSecondaryOpen;
    },
    setPrimaryMinimized(value: boolean) {
      this.isPrimaryMinimized = value;
    },
    setSecondaryOpen(value: boolean) {
      this.isSecondaryOpen = value;

      if (value) {
        this.isPrimaryMinimized = value;
      } else {
        this.isPrimaryMinimized = window.innerWidth < 1024;
      }
    },
    setPageCollapsed(pageId: string, isCollapsed: boolean) {
      this.collapsedPages[pageId] = isCollapsed;
    },
    getPageCollapsed(pageId: string): boolean {
      return this.collapsedPages[pageId] ?? false; // default: false
    },
  },
  getters: {},
});
